import md5 from "@/utils/md5Util";

const dateUtil = {
    dateFormat (date, format = 'YYYY-MM-DD HH:mm:ss') {
        const pad = (num) => num.toString().padStart(2, '0');
        const map = {
            YYYY: date.getFullYear(),
            MM: pad(date.getMonth() + 1),
            DD: pad(date.getDate()),
            HH: pad(date.getHours()),
            mm: pad(date.getMinutes()),
            ss: pad(date.getSeconds())
        };
        return format.replace(/YYYY|MM|DD|HH|mm|ss/g, matched => map[matched]);
    }
}
export default dateUtil;

